(() => {
  const key = 'filter.v.availability';
  const marker = 'lh_availability';
  const url = new URL(location.href);
  if (document.documentElement.hasAttribute('data-lh-search-all-stock')) {
    if (url.searchParams.has(key)) {
      url.searchParams.delete(key);
      url.searchParams.delete('page');
      location.replace(url.href);
    }
    return;
  }
  const collectionPage = document.documentElement.hasAttribute('data-lh-collection-availability');
  if (!collectionPage) return;
  if (!url.searchParams.has(key) && url.searchParams.get(marker) !== 'all') {
    url.searchParams.set(key, '1');
    url.searchParams.delete('page');
    location.replace(url.href);
    return;
  }
  const sidebarForm = target => target instanceof Element ? target.closest('form[data-collection-sidebar]') : null;
  const submitFilters = form => {
    const next = new URL(location.href);
    next.searchParams.delete('page');
    const representedNames = new Set([...form.elements].map(control => control.name).filter(Boolean));
    for (const name of representedNames) next.searchParams.delete(name);
    const data = new FormData(form);
    for (const [name, value] of data) {
      if (value !== '') {
        if (!name.startsWith('filter.')) next.searchParams.delete(name);
        next.searchParams.append(name, value);
      }
    }
    next.searchParams.set(marker, 'all');
    location.assign(next.href);
  };
  window.addEventListener('submit', event => {
    const form = sidebarForm(event.target);
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitFilters(form);
  }, true);
  window.addEventListener('change', event => {
    if (sidebarForm(event.target)) event.stopImmediatePropagation();
  }, true);
  window.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const form = sidebarForm(target);
    if (form) {
      const link = target.closest('a');
      if (link && link.querySelector('input')) link.removeAttribute('href');
      event.stopImmediatePropagation();
      return;
    }
    const link = target.closest('a[href]');
    if (!link || !link.closest('.ledhut-collection')) return;
    const next = new URL(link.href, location.href);
    if (next.origin !== location.origin || next.pathname !== location.pathname) return;
    {
      next.searchParams.set(marker, 'all');
      if (!next.searchParams.has('sort_by') && url.searchParams.has('sort_by')) next.searchParams.set('sort_by', url.searchParams.get('sort_by'));
      link.href = next.href;
      if (!event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
        location.assign(next.href);
      }
    }
  }, true);
})();